import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../../../components/ui/Chip';
import { Button } from '../../../components/ui/Button';
import { Card } from '../../../components/ui/Card';
import { formatPrice, PLANS } from '../../../config/plans';
import { cn } from '../../../lib/utils';

export function Pricing() {
  const navigate = useNavigate();

  return (
    <section id="pricing" className="scroll-mt-20 bg-bg">
      <div className="mx-auto max-w-[1240px] px-5 pb-12 pt-4 sm:px-8 sm:pb-16 sm:pt-6">
        <div className="mx-auto max-w-[620px] text-center">
          <p className="text-[13px] font-semibold uppercase tracking-[0.08em] text-link">Pricing</p>
          <h2 className="mt-3 text-[32px] font-bold leading-tight tracking-tight text-text sm:text-[44px]">
            Simple plans that grow with you.
          </h2>
          <p className="mt-4 text-lg text-text-2">Start free. Upgrade when your links do.</p>
        </div>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {PLANS.map((plan) => {
            const price = formatPrice(plan.monthly);
            return (
              <li key={plan.id} className="flex">
                <Card
                  padding="lg"
                  tint={plan.highlight}
                  className={cn('relative flex w-full flex-col', plan.highlight && 'border-brand-teal shadow-glow')}
                >
                  {plan.highlight && (
                    <Badge tone="teal" uppercase className="absolute right-6 top-6">
                      Popular
                    </Badge>
                  )}
                  <h3 className="text-lg font-semibold text-text">{plan.name}</h3>
                  <p className="mt-1 text-sm text-muted">{plan.tagline}</p>
                  <p className="mt-6 flex items-baseline gap-1">
                    <span className="text-[40px] font-bold leading-none tracking-tight text-text">{price}</span>
                    {plan.monthly > 0 && <span className="text-sm text-muted">/ month</span>}
                  </p>
                  <ul className="mt-8 flex flex-1 flex-col gap-3">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-start gap-2.5 text-[15px] text-text-2">
                        <Check className="mt-0.5 size-4 shrink-0 text-success" aria-hidden />
                        {f}
                      </li>
                    ))}
                  </ul>
                  <Button
                    block
                    variant={plan.highlight ? 'primary' : 'secondary'}
                    className="mt-8"
                    onClick={() => navigate('/register')}
                    aria-label={`Get started with ${plan.name}`}
                  >
                    Get started
                  </Button>
                </Card>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
